import Monto from "./Monto";

export default Monto;